<template>
  <div>
    <div class="content-item flex align-items-center">
      <div class="content-item-label"><span class="red">*</span>上传视频</div>
      <div
        class="item-video-wrap"
        element-loading-text="视频正在转码..."
        v-loading="videoLoading"
      >
        <input
          type="file"
          name="file"
          @change="onVideoChange"
          class="item-conver-input"
          accept="audio/mp4, video/mp4"
          ref="input"
        />
        <div
          class="item-conver flex align-items-center justify-content-center flex-direction-column"
        >
          <template v-if="!sucessVideo && !isShowProgress">
            <img src="~_img/upload.png" alt="图片上传" />
            <span>上传视频</span>
          </template>
          <div class="video-uploading" v-if="isShowProgress">
            <el-progress
              class="progress"
              type="circle"
              :percentage="progessPersen"
            ></el-progress>
            <span class="cancelVideo" @click.stop="cancelUploadedVod"
              >取消上传</span
            >
          </div>
          <div
            class="video-success"
            v-if="sucessVideo"
            @click.self="handleSuccessVideo"
          >
            <i class="el-icon-circle-check"></i>
            <span class="successText">上传成功</span>
            <span class="removeVideo" @click.stop="deleteUploadedVod"
              >删除视频</span
            >
          </div>
        </div>
      </div>
    </div>
    <p class="tips">只支持MP4格式，最大500M，上传时长约3-4分钟</p>
  </div>
</template>

<script>
/**
 * "articleVideoInfos": [
    {
      "articleId": 302796,
      "created": "2021-06-07 20:45:47",
      "creator": "jd_ntcUGAAHdoIc",
      "duration": 121,
      "fullImageUrl": "https://jvod.300hu.com/img/2021/81386173/1/img2.jpg",
      "height": 720,
      "id": 5997,
      "imageUrl": "https://jvod.300hu.com/img/2021/81386173/1/img2.jpg",
      "playUrl": "https://jvod.300hu.com/vod/product/73ee10e3-2bbb-490b-b5bc-7268b574e978/f3a9ce3f32c9490f8e1df28da7366dda.mp4",
      "size": 7425591,
      "updated": "2021-06-07 20:45:47",
      "uploadPin": "jd_ntcUGAAHdoIc",
      "uploadServerIp": "10.172.70.67",
      "vid": 578891699,
      "videoCode": 2,
      "videoMarks": "[]",
      "videoName": "1.mp4",
      "width": 1280,
      "yn": 1
    }]
 */
import { request } from "@/utils/axios";
import axios from "axios";
export default {
  name: "uploadVideo",
  props: ["form", "functionIds"],
  data() {
    return {
      // 视频生成封面图转码中状态
      videoLoading: false,
      // 进度百分比
      progessPersen: 0,
      cancelUploadedVodMethod: "",
      vid: "",
      // 视频上传中控制
      isShowProgress: false,
      sucessVideo: false,
    };
  },
  watch: {
    "form.articleVideoInfos": {
      handler(val) {
        if (val && val.length) {
          this.sucessVideo = true;
          this.vid = val[0].vid;
        } else {
          this.sucessVideo = false;
          this.vid = "";
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 设置视频ID到form表单中
    setVideoIdToForm(id) {
      if (
        this.form.articleVideoInfos &&
        this.form.articleVideoInfos.length > 0
      ) {
        this.form.articleVideoInfos[0].vid = id;
        if (!id) {
          // 如果是清空操作，删除视频ID也要删除视频封面图的URL
          this.form.articleVideoInfos[0].imageUrl = "";
        }
      } else {
        this.form.articleVideoInfos = [
          {
            vid: id,
            imageUrl: "",
          },
        ];
      }
    },
    //视频上传相关接口
    async onVideoChange() {
      let file = this.$refs.input.files[0];
      if (file.type !== "video/mp4") {
        return this.$message.error("视频仅支持mp4格式");
      }
      let isSize500 = file.size / 1024 / 1024 <= 500;

      this.progessPersen = 0;

      if (!isSize500) {
        this.$message.error("视频文件不得超过500M");
        this.$refs.input.value = "";
        return;
      }

      // 调取后端接口，获取上传视频的接口链接和视频ID
      // getVodUploadUrl返回：1.1 视频上传信息（UploadURlDTO）
      // videoId	Long	视频id
      // uploadUrl String 上传地址
      // uploadUrlHttps String https上传地址
      let res = await request(this.functionIds.getVodUploadUrl, {
        videoName: file.name,
        fileSize: file.size,
      });
      let uploadUrl =
        window.location.protocol == "http:"
          ? res.uploadUrl
          : res.uploadUrlHttps;
      if (uploadUrl) {
        await this.uploadVideo(file, uploadUrl);
      }
      this.vid = res.videoId || "";
      this.$refs.input.value = "";
      this.setVideoIdToForm(this.vid);
    },
    uploadVideo(file, baseUrl) {
      this.isShowProgress = true;
      var formData = new FormData();
      formData.append("file", file); //这是获取上传的文件
      axios({
        method: "POST",
        url: baseUrl,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          //原生获取上传进度的事件
          if (progressEvent.lengthComputable) {
            //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
            //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
            var complete =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0;
            this.progessPersen = complete;
          }
        },
        data: formData,
        cancelToken: new axios.CancelToken((c) => {
          this.cancelUploadedVodMethod = c;
        }),
      })
        .then((res) => {
          if (this.progessPersen == 100) {
            this.isShowProgress = false;
            this.sucessVideo = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.isShowProgress = false;
          this.$refs.input.value = "";
        });
    },
    cancelUploadedVod() {
      this.cancelUploadedVodMethod();
    },
    handleSuccessVideo() {
      this.$message.error("只能上传一个视频");
    },
    deleteUploadedVod() {
      request(this.functionIds.deleteUploadedVod, {
        vid: this.vid,
      })
        .then((res) => {
          this.sucessVideo = false;
          this.vid = "";
          this.setVideoIdToForm("");
          // 视频和视频封面图组件是同级组件，这里删除视频也要删除视频封面图，
          // 所以判断封面图组件是否存在，如果存在则删除封面图.
          if (this.$parent.$refs.uploadPosterImgRef) {
            this.$parent.$refs.uploadPosterImgRef.posterPicUrl = [];
            this.$parent.$refs.uploadPosterImgRef.uploadVideoPicSuccess = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * @desc 由于上传视频之后立即保存文章，后台生成视频封面图需要时间，
     *       不会马上返回封面图的数据，所以这里需要特殊处理下。
     */
    displayDataToHtml() {
      if (
        this.form.articleVideoInfos &&
        this.form.articleVideoInfos.length > 0
      ) {
        // 后台视频未上传完毕
        if (this.form.articleVideoInfos[0].playUrl === undefined) {
          this.videoLoading = true;
          // 视频文件后台没有及时返回, 需要重复获取
          this.videoInterval = setInterval(() => {
            request(this.functionIds.searchArticleById, {
              articleId: this.form.id,
              tenantId: this.$commonJs.getTenantId(),
            }).then((res1) => {
              if (res1.articleVideoInfos[0].playUrl) {
                clearInterval(this.videoInterval);
                this.form.articleVideoInfos = res1.articleVideoInfos;
                this.showVideo(res1);
                this.videoLoading = false;
              }
            });
          }, 1000);
        } else {
          // 返显视频封面
          this.showVideo(this.form);
        }
      }
    },
    /**
     * @desc 根据文章返回的结果界面反显视频信息
     * @param res 文章数据
     */
    showVideo(res) {
      // 如果没有上传视频文件，该对象为空。
      if (!res.articleVideoInfos || !res.articleVideoInfos.length) {
        return;
      }
      //返显示视频
      this.vid = res.articleVideoInfos[0].vid;
      this.isShowProgress = false;
      this.sucessVideo = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-video-wrap {
  position: relative;
  width: 230px;
  height: 150px;
  .item-conver-input {
    width: 230px;
    height: 150px;
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }
  .item-conver {
    width: 230px;
    height: 150px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 12px;
    color: #989ca5;
    img {
      margin-bottom: 8px;
    }
    .video-uploading {
      width: 100%;
      height: 100%;
      color: #52c464;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      padding-top: 10px;
      :deep(.el-progress-circle) {
        width: 100px !important;
        height: 100px !important;
      }
      .cancelVideo {
        position: absolute;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        height: 30px;
        line-height: 30px;
        width: 100%;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
      }
    }
    .video-success {
      width: 100%;
      height: 100%;
      color: #52c464;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: relative;
      .el-icon-circle-check {
        font-size: 28px;
        margin-bottom: 7px;
      }
      .removeVideo {
        position: absolute;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        height: 30px;
        line-height: 30px;
        width: 100%;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
      }
    }
  }
}
</style>
